export default __webpack_public_path__ + "static/media/copper1.3873efe7.png";